import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";


const Hadear = () => {
  const [toggle, setToggle] = useState(false);
  const CloseClick = () => {
    setToggle(false);

  };
  const [ismobile, setIsmobile] = useState(0);

  // const { categorytotal } = useSelector((store) => store.categoryAll);


  const [showAbout, setShowAbout] = useState(true);
  const [showInterior, setShowInterior] = useState(true);
  const [showGallery, setShowGallery] = useState(true);

  const closemenu = () => {
    document.getElementById("mytogglebtn").classList.add("collapsed");
    document.getElementById("menu").classList.remove("in");
  };



  const [name, setName] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [subject, setSubject] = useState("");
  const [city, setCity] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const stateChange = (e) => {
    const value = e.target.value;
    setState(value);
  };
  const cityChange = (e) => {
    const value = e.target.value;
    setCity(value);
  };
  const subjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
  };
  const numberChange = (e) => {
    const value = e.target.value;
    setNumber(value);
  };

  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };


  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(

      // "service_oumku8k",
      // "template_esy4tqm",
      // "#myForm",
      // "8i7i_APkS7sZ9CqPl"
    )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setmail("");
            setMassages("");
            setNumber("");
            setState("");
            setSubject("");
            setCity("");

          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };
  return (
    <>


      <header className="header">
        <div className="header-top">
          <div className="shape">
            <div className="shape-1" />
            <div className="shape-2" />
          </div>
          <div className="container pe-0">
            <div className="header-top-wrap">
              <div className="header-top-left">
                <div className="header-top-list">
                  <ul>
                    <li style={{ marginLeft: "50px", color:"white" }}>
                      <a to="mailto:yogeshsolarenergy2026@gmail.com">
                        {/* <i className="far fa-envelopes" /> */}
                        GST:- 23JTYPK1825D1ZG</a></li>
                    <li>
                      <a href="tel:+917024671002"><i className="far fa-phone-volume" /> +91 7024671002, +91 7240954834</a>
                    </li>
                    <li>
                      <Link href="/"><i style={{ color: "white", marginLeft: "10px" }} className="far fa-alarm-clock" /> Sun - Fri (08AM - 10PM)</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="header-top-right">
                <div className="header-top-social" style={{ marginLeft: "79px" }}>
                  <span>Follow Us: </span>
                  <a href="https://www.instagram.com/yogeshsolarenergy/?utm_source=ig_web_button_share_sheet" target="_blank"><i className="fab fa-instagram" /></a>
                  <a href="https://wa.me/917240954834" target="_blank"><i className="fab fa-whatsapp" /></a>
                  {/* <a href="/" target="_blank"><i className="fa fa-question-circle" /></a> */}
                  <a href='https://jsdl.in/DT-99A7F5SMMF2' target="_blank">
                    <img
                      src="./assets/yog/justdial.png"
                      width="50px"
                      className=""
                      style={{ height: "18px", width: "18px", margin: "" }}
                    />
                  </a>
                  <a href="/" target="_blank"><i className="fab fa-facebook" /></a>
                  <a href="/" target="_blank"><i className="fab fa-youtube" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="main-navigation">
          <nav className="navbar navbar-expand-lg">
            <div className="container position-relative">
              <Link className="navbar-brand" to="/">
                <img src="./assets/yog/Yogesh_logo.png" style={{ width: "70px", height: "70px" }} alt="logo" />
              </Link>
              <div className="mobile-menu-right">
                <div className="mobile-menu-btn">
                  {/* <button type="button" className="nav-right-link search-box-outer"><i className="far fa-search" /></button> */}
                </div>
                <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                  <span />
                  <span />
                  <span />
                </button>
              </div>
              <div className="offcanvas offcanvas-start" tabIndex={-1} id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                <div className="offcanvas-header">
                  <Link to="/" className="offcanvas-brand" id="offcanvasNavbarLabel">
                    <img src="./assets/yog/Yogesh_logo.png" style={{ width: "70px", height: "70px" }} alt />
                  </Link>
                  <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"><i className="far fa-xmark" /></button>
                </div>
                <div className="offcanvas-body">
                  <ul className="navbar-nav justify-content-end flex-grow-1">
                    <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
                    <li className="nav-item"><Link className="nav-link" to="/about">About Us</Link></li>
                    <li className="nav-item dropdown">
                      <a className="nav-link dropdown-toggle" to="#" data-bs-toggle="dropdown">Services</a>
                      <ul className="dropdown-menu fade-down">
                        <li><Link className="dropdown-item" to="/solar-electrical-installation">Solar & Electrical Installation</Link></li>
                        <li><Link className="dropdown-item" to="/on-grid-off-grid-solar">On-Grid & Off-Grid Solar</Link></li>
                        <li><Link className="dropdown-item" to="/hybrid-solar-power-plant">Hybrid Solar Power Plant</Link></li>
                        <li><Link className="dropdown-item" to="/EV-charging-solution">EV Charging Solution</Link></li>
                        <li><Link className="dropdown-item" to="/solar-water-pump-solution">Solar Water Pump Solution</Link></li>
                        <li><Link className="dropdown-item" to="/solar-water-heater-solution">Solar Water Heater Solution</Link></li>
                        <li><Link className="dropdown-item" to="/energy-efficient-building">Energy Efficient Building</Link></li>
                      </ul>
                    </li>

                    <li className="nav-item"><a className="nav-link" to="contact.html">Our Team</a></li>
                    <li className="nav-item"><Link className="nav-link" to="/blog">Blog & Updates</Link></li>
                    <li className="nav-item"><Link className="nav-link" to="/gallery">Our Gallery</Link></li>
                    <li className="nav-item"><Link className="nav-link" to="/contact-us">Contact Us</Link></li>
                  </ul>
                  <div className="nav-right">


                    <div className="nav-btn">
                      <Link to="/contact-us" className="theme-btn">Order Book<i className="fas fa-arrow-right" /></Link>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>

      </header>



    </>
  )
}
export default Hadear